// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const GO_SEARCH = "Hledej";
export const SEO_BREADCRUMB_FORUM_SEARCH = "Vyhled\u00e1v\u00e1n\u00ed";
export const SEO_TITLE_FORUM_SEARCH = "Vyhled\u00e1v\u00e1n\u00ed v diskuz\u00edch";
